import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {

  constructor() { }

  static getItem(name): string {
    return localStorage.getItem(name);
  }

  static removeItem(name): void {
    localStorage.removeItem(name);
  }

  static setItem(name, value) {
    return localStorage.setItem(name, value);
  }
}
